import { ReactNode } from 'react';

interface AppShellProps {
  children: ReactNode;
}

/**
 * AppShell - Main layout wrapper for the application
 * 
 * Provides the top-level structure for the application with semantic HTML.
 * This component wraps all page content and provides consistent layout structure.
 */
export function AppShell({ children }: AppShellProps) {
  return (
    <div className="app-shell">
      <main>{children}</main>
    </div>
  );
}
